<template lang="pug">
  b-overlay(:show="loading", variant="transparent", spinner-variant="primary")
    b-card
      transition(name="fade")
        b-form.mb-3(v-if="edit_mode")
          b-form-group(label-size="sm")
            template(#label)
              .d-flex.justify-content-between
                p.mb-0 Nombre
                trash-2-icon.icon-md.hover-danger.pointer.text-secondary(@click="confirmDestroy")
            b-form-input(placeholder="Nombre del Objetivo", v-model="sequence.name", @input="updateSequence")
          b-form-group(label="Descripción", label-size="sm")
            b-form-textarea(placeholder="Descripción", v-model="sequence.description", rows="1", max-rows="2", no-resize, @input="updateSequence")
          .d-flex.justify-content-between.align-items-start
            b-form-group(:description="has_case_sequence ? 'Solo puede existir una secuencia para casos' : ''")
              b-form-checkbox(v-model="sequence.for_cases", @change="updateSequence", :disabled="has_case_sequence") Aplicar secuencia en casos
            b-button(variant="secondary", @click="edit_mode = false") Cerrar
      b-form-row.align-items-center.justify-content-between(v-if="!edit_mode")
        b-col.d-flex.align-items-center
          h5.mb-0 {{sequence.name}}
          inbox-icon.icon-md.text-secondary.ml-2.hover-primary(v-if="sequence.for_cases", v-b-tooltip.hover="'Secuencia para casos'")
        b-col(cols="auto")
          b-form-checkbox(switch, v-model="sequence.enabled", @change="updateSequence") {{sequence.enabled ? 'Activada' : 'Desactivada'}}
        b-col(cols="auto")
          b-button(variant="primary", size="sm", @click="createAction") Agregar acción
        b-col(cols="auto")
          b-button(variant="outline", size="sm", @click="edit_mode = true")
            edit3-icon.icon-md
      .text-secondary.mb-3 {{sequence.description}}
      b-card.shadow(v-for="action in actions", :key="action.follow_up_action_id")
        b-form-row.justify-content-end.justify-content-md-between.align-items-md-center.mb-2
          b-col
            b-dropdown.mr-2.mb-2.mb-md-0(:text="getLabel(action)", size="sm", variant="light", :menu-class="['filters-dropdown']")
              b-dropdown-form
                b-form-radio-group(v-model="action.action", :options="action_options", @change="updateAction(action)", stacked)
            b-dropdown.mb-2.mb-md-0(:text="action.after_time ? $moment.duration(action.after_time, 'minutes').humanize() : 'de inmediato'", size="sm", variant="light", :menu-class="['filters-dropdown']")
              b-dropdown-header La se secuencia se ejecutará {{action.after_time ? 'después de ' + $moment.duration(action.after_time, 'minutes').humanize() : 'de inmediato'}}
              b-dropdown-form
                b-form-group(label="Unidad de tiempo", label-size="sm")
                  b-form-radio-group(v-model="action.time_type", :options="time_units", size="sm", stacked, @change="updateTime(action)")
                b-form-group(:label="`Cantidad en ${getTimeLabel(action)}`", :description="action.after_time <= 0 ? 'La secuencia se ejecutará de inmediato' : ''" label-size="sm")
                  b-form-input(type="number", placeholder="Tiempo", v-model="action.time_value", @input="updateTime(action)", min="0", step="1", :max="getMaxTime(action)")
          b-col(cols="auto")
            trash-2-icon.icon-md.hover-danger.pointer.text-secondary(@click="confirmDestroyAction(action)")
        b-form-group(:description="action.action === 'send_text_current_block' ? 'Se reenviá al bloque actual después del mensaje' : ''")
          block-connector(v-bind="action.payload", v-if="action.action === 'next_block'", @change="updateNextBlock($event, action)")
          b-form-textarea(v-model="action.payload.text", rows="2", max-rows="6", placeholder="Mensaje a enviar", v-else, @input="updateAction(action)")
</template>

<script>
import _debounce from "lodash.debounce";
import {createNamespacedHelpers, mapActions} from "vuex";
const flowController = createNamespacedHelpers('flow')
const fuaController = createNamespacedHelpers('follow_up_action')
const sequenceController = createNamespacedHelpers('sequence')

export default {
  data () {
    return {
      loading: false,
      edit_mode: false,
      loading_sequence: null,
      options: [
        { text: 'Enviar mensaje', value: 'send_text' },
        { text: 'Enviar mensaje y reenviar a bloque actual', value: 'send_text_current_block' },
        { text: 'Conectar con un bloque', value: 'next_block' }
      ],
      time_units: [
        { text: 'Minutos', value: 'minutes' },
        { text: 'Horas', value: 'hours' },
        { text: 'Dias', value: 'days' },
      ],
      sequence: {
        sequence_id: null,
        name: "",
        description: "",
        enabled: false,
        for_cases: false,
      },
    }
  },
  computed: {
    ...flowController.mapState({
      flows: state => state.flows
    }),
    ...fuaController.mapState({
      actions: state => state.follow_up_actions
    }),
    ...sequenceController.mapGetters(['case_sequence']),
    action_options () {
      return this.options.filter(el => {
        return this.sequence.for_cases ? el.value !== 'send_text_current_block' : true
      })
    },
    has_case_sequence () {
      return this.case_sequence && this.case_sequence != this.sequence.sequence_id
    }
  },
  methods: {
    ...mapActions(['sequence/get', 'sequence/update', 'sequence/destroy',
                  'follow_up_action/all', 'follow_up_action/create', 'follow_up_action/update', 'follow_up_action/destroy']),
    getSequence () {
      let self = this
      this.loading = true

      this['sequence/get']({
        sequence_id: self.$route.params.sequence_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.sequence = Object.assign(self.sequence, res.resource)
          }
        }
      })
    },
    getActions () {
      let self = this
      this.loading = true

      this['follow_up_action/all']({
        sequence_id: self.$route.params.sequence_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    updateSequence: _debounce(function () {
      let self = this
      this.loading = true

      this['sequence/update']({
        ...this.sequence,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Secuencia actualizada')
          }
        }
      })
    }, 1000, {leading: false, trailing: true}),
    confirmDestroy () {
      this.$bvModal.msgBoxConfirm(`¿Deseas eliminar la secuencia? No se puede deshacer.`, {
        title: 'Eliminar secuencia',
        okTitle: 'Eliminar',
        okVariant: 'danger',
        cancelTitle: 'Cancelar'
      }).then(value => {
        if (value === true) {
          this.destroySequence()
        }
      })
    },
    destroySequence () {
      let self = this
      this.loading = true

      this['sequence/destroy']({
        ...this.sequence,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$router.push({name: 'Sequences'}).catch(()=>{});
          }
        }
      })
    },
    createAction () {
      let self = this
      this.loading = true

      this['follow_up_action/create']({
        sequence_id: self.$route.params.sequence_id,
        action: 'send_text',
        after_time: 1,
        payload: JSON.stringify({text: ''}),
        step: this.actions.length + 1,
        callback: res => {
          this.loading = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    updateNextBlock (event, action) {
      action.payload.next_block_id = event.next_block_id
      this.updateAction(action)
    },
    updateAction: _debounce(function (action) {
      let self = this
      this.loading = true

      this['follow_up_action/update']({
        ...action,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Acción de secuencia actualizada')
          }
        }
      })
    }, 1000, {leading: false, trailing: true}),
    confirmDestroyAction(action) {
      this.$bvModal.msgBoxConfirm(`¿Deseas eliminar la acción? No se puede deshacer.`, {
        title: 'Eliminar acción',
        okTitle: 'Eliminar',
        okVariant: 'danger',
        cancelTitle: 'Cancelar'
      }).then(value => {
        if (value === true) {
          this.destroyAction(action)
        }
      })
    },
    destroyAction (action) {
      let self = this
      this.loading = true

      this['follow_up_action/destroy']({
        ...action,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Acción de secuencia eliminada')
          }
        }
      })
    },
    updateStep: _debounce(function (step) {
      if(!step.title) return
      let self = this
      this.loading_sequence = step._id

      this['sequence/updateStep']({
        sequence_id: this.$route.params.sequence_id,
        ...step,
        callback: res => {
          self.loading_sequence = null
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Secuencia actualizada')
          }
        }
      })
    }, 1000, {leading: false, trailing: true}),
    getLabel({action}) {
      let option = this.options.find(el => el.value === action)
      return option ? option.text : 'Acción'
    },
    getTimeLabel({time_type}) {
      let option = this.time_units.find(el => el.value === time_type)
      return option ? option.text : 'minutos'
    },
    getMaxTime({time_type}) {
      switch (time_type) {
        case 'minutes':
          return 60
        case 'hours':
         return  24
        case 'days':
         return 1
      }
    },
    updateTime (action) {
      if(action.time_value <= 0) action.time_value = 0
      action.time_value = Math.floor(action.time_value)
      switch (action.time_type) {
        case 'minutes':
          if(action.time_value > 60) action.time_value = 59
          action.after_time = action.time_value
          break
        case 'hours':
          if(action.time_value > 23) action.time_value = 23
          action.after_time = action.time_value * 60
          break
        case 'days':
          if(action.time_value > 1) action.time_value = 1
          action.after_time = action.time_value * 60 * 24
          break
      }
      this.updateAction(action)
    },
  },
  mounted() {
    this.getSequence()
    this.getActions()
  }
}
</script>

<style lang="scss" scoped>

</style>
